import React from 'react';
import styles from './index.module.less';
import { Pagination, PaginationProps } from 'antd';
import cn from 'classnames';

const ThemePagination: React.FC<PaginationProps> = props => {
    const {
        className,
        size = 'small',
        showSizeChanger = false,
        ...rest
    } = props;
    return (
        <Pagination
            className={cn(className, styles.pagination)}
            size={size}
            showSizeChanger={showSizeChanger}
            // hack：antd 页面使用的 a 标签没有href属性导致报错：Cannot read properties of null (reading 'match')
            itemRender={(page, type: string, originalElement: React.ReactNode) => type === 'page' ? <span>{page}</span> : originalElement}
            {...rest}
        />
    )
};

export default ThemePagination;